import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PanoramaVerticalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"panorama_vertical"}/>
}
